import { createApp, nextTick } from 'vue';
import App from './App.vue';
import router from './router';
import IconButton from '@/components/IconButton.vue';
import i18n from '@/i18n';

import '@/assets/css/bootstrap.min.css';
import '@/assets/css/bootstrap-overrides.css';
import '@/assets/css/style.css';
import '@/assets/css/dashboard-icons.css';

let app = createApp(App).use(router).use(i18n);

//===============================================
// Mixins

import AjaxMixin from './mixins/AjaxMixin';
import WindowDimensionsMixin from './mixins/WindowDimensionsMixin';
import SectorTerminologyMixin from './mixins/SectorTerminologyMixin';
app.mixin(AjaxMixin);
app.mixin(WindowDimensionsMixin);
app.mixin(SectorTerminologyMixin);

//===============================================
// Config environment (dev vs prod)

let apiRoot = null;
let environment = null;
const hostname = window.location.hostname;
const isPrivateNetworkHost = (host) => {
    return (
        host == 'localhost' ||
        host == '127.0.0.1' ||
        host == '::1' ||
        /^10\./.test(host) ||
        /^192\.168\./.test(host) ||
        /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
    );
};
const developmentApiRoot = () => {
    if (hostname == 'localhost' || hostname == '127.0.0.1') {
        return process.env.VUE_APP_API_URL_DEV;
    }

    return `${window.location.protocol}//${hostname}:3000/api/`;
};

if (isPrivateNetworkHost(hostname)) {
    apiRoot = developmentApiRoot();
    environment = 'development';
} else if (
    hostname == 'beta.app.ipacdashboard.com' ||
    window.location.origin == process.env.VUE_APP_URL_BETA
) {
    apiRoot = process.env.VUE_APP_API_URL_BETA;
    environment = 'beta';
} else if (
    hostname == 'app.ipacdashboard.com' ||
    window.location.origin == process.env.VUE_APP_URL_PROD
) {
    apiRoot = process.env.VUE_APP_API_URL_PROD;
    environment = 'production';
}

app.config.globalProperties.$env = {
    apiRoot: apiRoot,
    environment: environment,
};

//===============================================
// Stores

import { createPinia } from 'pinia';
import { useUserStore } from './stores/user';
import { usePermissionStore } from './stores/permission';
import { useAlertStore } from './stores/alert';
import { useEmployeesStore } from './stores/employees';
import { useSiteStore } from './stores/site';
import { useRoleStore } from './stores/role';

// Make frequently-used "user" store global for ease of access
let pinea = createPinia();
app.use(pinea);

app.config.globalProperties.$alertStore = useAlertStore();

const userStore = useUserStore();
app.config.globalProperties.$userStore = userStore;

const permissionStore = usePermissionStore();
app.config.globalProperties.$permStore = permissionStore;

const employeesStore = useEmployeesStore();
app.config.globalProperties.$employeesStore = employeesStore;

const siteStore = useSiteStore();
app.config.globalProperties.$siteStore = siteStore;

const roleStore = useRoleStore();
app.config.globalProperties.$roleStore = roleStore;

app.component('IconButton', IconButton);

nextTick(() => {
    userStore.sync();
});

app.mount('#app');
export default app;
